'use strict';
var ErrorLayout = require('helper/layout-helper').errorLayout;
var AppError = require('../../utils/appError');
var React = require('react');

var NotDeniedPage = React.createClass({
  render: function () {
    return (
      <ErrorLayout error={new AppError(AppError.CODE_ACCESS_DENIDED)}/>
    );
  }
});

module.exports = NotDeniedPage;
